export default __webpack_public_path__ + "100e2bcc5b1bfb852f09ca942494ba71.png";